//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import actionCableMixin from "../mixins/ws/actionCable";
export default {
  mixins: [actionCableMixin],
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      timer: null,
      minValue: -1000000,
      maxValue: 1000000,
      days_mode: null,
      displayDays: 0,
      displayHours: 0,
      displayMinutes: 0,
      displaySeconds: 0
    };
  },
  computed: {
    _seconds: function _seconds() {
      return 1000;
    },
    _minutes: function _minutes() {
      return this._seconds * 60;
    },
    _hours: function _hours() {
      return this._minutes * 60;
    },
    _days: function _days() {
      return this._hours * 24;
    },
    end: function end() {
      return new Date(this.spec.value);
    }
  },
  methods: {
    $ready: function $ready() {
      var _this = this;

      if (this.days_mode = this.$classes().includes("days")) {
        this.showRemaining();
      }

      this.$wsInitActionCable(this.spec.actionCable);
      Utils.type.ifNumber(this.spec.min, function (value) {
        _this.minValue = value;
      });
      Utils.type.ifNumber(this.spec.max, function (value) {
        _this.maxValue = value;
      });
      Utils.type.ifNumber(this.spec.value, function (value) {
        if (value !== null) {
          _this.fieldModel = value;
        }

        _this.timer = setInterval(function () {
          _this.adjustValue();
        }, 1000);
      });
    },
    adjustValue: function adjustValue() {
      if (this.spec.forward) {
        if (this.fieldModel < this.maxValue) {
          this.fieldModel += 1;
        }
      } else {
        if (this.fieldModel > this.minValue) {
          this.fieldModel -= 1;
        }
      }
    },
    $tearDown: function $tearDown() {
      console.log("Cleaning up timer...");

      if (this.timer != null) {
        clearInterval(this.timer);
        console.log("Timer stopped: ".concat(this.timer));
        this.timer == null;
      }
    },
    action_set: function action_set(spec) {
      var _this2 = this;

      Utils.type.ifNumber(spec.value, function (value) {
        _this2.fieldModel = value;
      });
    },
    classes: function classes() {
      return this.$classes().concat("g-text-field--hintless");
    },
    // days_mode methods
    formatNum: function formatNum(num) {
      return num < 10 ? "0" + num : num;
    },
    showRemaining: function showRemaining() {
      var _this3 = this;

      setInterval(function () {
        _this3.now = new Date();
        _this3.fieldModel = _this3.end.getTime() - _this3.now.getTime();

        if (_this3.fieldModel < 0) {
          clearInterval(_this3.timer);
          return;
        }

        var days = Math.floor(_this3.fieldModel / _this3._days);
        var hours = Math.floor(_this3.fieldModel % _this3._days / _this3._hours);
        var minutes = Math.floor(_this3.fieldModel % _this3._hours / _this3._minutes);
        var seconds = Math.floor(_this3.fieldModel % _this3._minutes / _this3._seconds);
        _this3.displayMinutes = _this3.formatNum(minutes);
        _this3.displaySeconds = _this3.formatNum(seconds);
        _this3.displayHours = _this3.formatNum(hours);
        _this3.displayDays = _this3.formatNum(days);
      });
    }
  }
};